import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoVedute = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		filter: "url(#filter0_d_1427_14492)",
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			rx: 5,
			fill: "#E9F1F3",
			shapeRendering: "crispEdges"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M9.57812 13.125H10.5156V9.375H9.57812V13.125ZM9.99972 8.21875C10.1457 8.21875 10.2682 8.17083 10.3672 8.075C10.4661 7.97917 10.5156 7.86042 10.5156 7.71875C10.5156 7.56823 10.4662 7.44206 10.3675 7.34023C10.2687 7.23841 10.1463 7.1875 10.0003 7.1875C9.85426 7.1875 9.73177 7.23841 9.63281 7.34023C9.53385 7.44206 9.48437 7.56823 9.48437 7.71875C9.48437 7.86042 9.53376 7.97917 9.63253 8.075C9.73131 8.17083 9.85371 8.21875 9.99972 8.21875ZM10.0042 16.25C9.14234 16.25 8.33245 16.0859 7.57447 15.7578C6.81649 15.4297 6.15365 14.9818 5.58594 14.4141C5.01823 13.8464 4.57031 13.1831 4.24219 12.4244C3.91406 11.6656 3.75 10.8549 3.75 9.99219C3.75 9.12949 3.91406 8.31877 4.24219 7.56002C4.57031 6.80125 5.01823 6.14062 5.58594 5.57812C6.15365 5.01562 6.81688 4.57031 7.57564 4.24219C8.33439 3.91406 9.14511 3.75 10.0078 3.75C10.8705 3.75 11.6812 3.91406 12.44 4.24219C13.1987 4.57031 13.8594 5.01562 14.4219 5.57812C14.9844 6.14062 15.4297 6.80208 15.7578 7.5625C16.0859 8.32292 16.25 9.13403 16.25 9.99584C16.25 10.8577 16.0859 11.6676 15.7578 12.4255C15.4297 13.1835 14.9844 13.8454 14.4219 14.4112C13.8594 14.977 13.1979 15.4249 12.4375 15.7549C11.6771 16.085 10.866 16.25 10.0042 16.25ZM10.0078 15.3125C11.4818 15.3125 12.7344 14.7943 13.7656 13.7578C14.7969 12.7214 15.3125 11.4661 15.3125 9.99219C15.3125 8.51823 14.7979 7.26562 13.7686 6.23437C12.7393 5.20312 11.4831 4.6875 10 4.6875C8.53125 4.6875 7.27865 5.20215 6.24219 6.23144C5.20573 7.26074 4.6875 8.51693 4.6875 10C4.6875 11.4687 5.20573 12.7214 6.24219 13.7578C7.27865 14.7943 8.53385 15.3125 10.0078 15.3125Z",
			fill: "#118AB2"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_1427_14492",
		x: 0,
		y: 0,
		width: 21,
		height: 21,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 1,
				dy: 1
			}),
			/* @__PURE__ */ _jsx("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.0666667 0 0 0 0 0.541176 0 0 0 0 0.698039 0 0 0 0.23 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_1427_14492"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_1427_14492",
				result: "shape"
			})
		]
	}) })]
});
export default SvgInfoVedute;
